// extracted by mini-css-extract-plugin
export default {"container":"greeting_container__b1Ovx"};